import { render, staticRenderFns } from "./Logic.vue?vue&type=template&id=59510c2a&scoped=true&"
import script from "./Logic.vue?vue&type=script&lang=js&"
export * from "./Logic.vue?vue&type=script&lang=js&"
import style0 from "./Logic.vue?vue&type=style&index=0&id=59510c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59510c2a",
  null
  
)

export default component.exports